/**
 * De pagina stil zetten zolang er iets overheen staat -- een video, de showreel.
 *
 * Twee dingen tegelijk, want er zijn twee scrollbronnen. Lenis luistert op window en
 * blijft gewoon doorlopen als je alleen overflow op de body zet; die moet je apart
 * pauzeren. En zonder overflow op de body scrollt de pagina alsnog met het toetsenbord of
 * de balk zelf.
 *
 * Het lastige zit in de balk. Verdwijnt die bij het vergrendelen, dan wordt het venster
 * een centimeter breder en verspringt de hele pagina eronder -- je ziet hem opzij klappen
 * op het moment dat het venster opengaat, en terug bij het sluiten.
 *
 * De nette oplossing daarvoor is scrollbar-gutter: stable in de CSS: die houdt de ruimte
 * van de balk altijd vrij, ook als er niets te scrollen valt, dus het venster verandert
 * nooit van breedte. Browsers die dat niet kennen krijgen hier de oude weg: meten hoe
 * breed de balk was en dat als padding teruggeven.
 *
 * Op een Mac met zwevende balken is die breedte nul en gebeurt er in beide gevallen niets
 * -- daar was er ook niets aan de hand.
 *
 * Meerdere vensters tegelijk komen niet voor, maar een teller kost niets en voorkomt dat
 * het sluiten van het ene het andere vrijgeeft.
 */

import { getLenis } from './smooth-scroll';

let diepte = 0;

/**
 * Kent de browser scrollbar-gutter? Dan regelt de CSS het en hoeven we hier niets te
 * compenseren.
 */
function gutterWerkt() {
  return typeof CSS !== 'undefined'
    && typeof CSS.supports === 'function'
    && CSS.supports('scrollbar-gutter', 'stable');
}

export function lockScroll() {
  diepte += 1;

  if (diepte > 1) {
    return;
  }

  const lenis = getLenis();

  if (lenis) {
    lenis.stop();
  }

  if (! gutterWerkt()) {
    const balk = window.innerWidth - document.documentElement.clientWidth;

    if (balk > 0) {
      document.body.style.paddingRight = `${balk}px`;
    }
  }

  document.body.style.overflow = 'hidden';
}

export function unlockScroll() {
  diepte = Math.max(0, diepte - 1);

  if (diepte > 0) {
    return;
  }

  const lenis = getLenis();

  if (lenis) {
    lenis.start();
  }

  document.body.style.overflow = '';
  document.body.style.paddingRight = '';
}
